import * as React from "react";
import {css, useTheme} from "@emotion/react";

import {borderRadius, color, elevation, mb, mh, mt, mv, p, pb, textAlign} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {numberFormat, pluralize} from "@pg-mono/string-utils";
import {LISTING_VENDOR_TEST_IDS} from "@pg-mono/test-ids";

import {MapOfPoland} from "../../atoms/map/MapOfPoland";
import {useBoxHandlerWithAnchor} from "../../hooks/use_box_handler_with_anchor";
import {useResponsiveLinkTarget} from "../../hooks/useResponsiveLinkTarget";

export interface IVendorBox {
    vendor: IVendorBoxVendor;
}

export interface IVendorBoxVendor {
    id: number;
    logo: {
        v_log_120x90: string;
    };
    name: string;
    headquarters: {
        type: 1 | 2;
        address: string;
        region: {
            id: number;
            full_name: string;
        };
    };
    regions: string[] | null;
    slug: string;
    stats: {
        offers_count_for_sale: number;
        properties_count_for_sale: number;
    };
}

export const VendorBox = (props: IVendorBox) => {
    const theme = useTheme();
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const vendorLink = rpAppLink.vendor.detail.base({vendorSlug: props.vendor.slug, vendorId: props.vendor.id});
    const offerPluralize = pluralize(["inwestycja", "inwestycje", "inwestycji"]);
    const propertyPluralize = pluralize(["nieruchomość", "nieruchomości", "nieruchomości"]);
    const vendorBoxHandler = useBoxHandlerWithAnchor(vendorLink);

    return (
        <div css={vendorBoxBase} onClick={vendorBoxHandler} data-testid={LISTING_VENDOR_TEST_IDS.CARD}>
            <Image alt={`${props.vendor.name} logo`} src={props.vendor.logo.v_log_120x90} css={vendorLogoStyle} height="90" width="auto" />
            <Text as="h2" variant="headline_4" css={[mt(0), mb(0.5), p(0), textAlign("center")]} className="bt">
                <a href={vendorLink} css={vendorBoxLink} title={props.vendor.name} target={responsiveLinkTarget}>
                    {props.vendor.name}
                </a>
            </Text>

            {props.vendor.headquarters && (
                <Text as="address" variant="info_txt_3" css={[mb(4), textAlign("center"), color(theme.colors.gray["600"])]}>
                    {props.vendor.headquarters.region.full_name}, {props.vendor.headquarters.address}
                </Text>
            )}

            <div css={[vendorMapHolder]} data-testid={LISTING_VENDOR_TEST_IDS.MAP_CONTAINER}>
                <MapOfPoland regions={props.vendor.regions} />
            </div>

            {props.vendor.stats.offers_count_for_sale > 0 && (
                <Text as="p" variant="info_txt_1" css={[textAlign("center"), pb(1)]}>
                    {numberFormat(props.vendor.stats.offers_count_for_sale)} {offerPluralize(props.vendor.stats.offers_count_for_sale)} w sprzedaży
                </Text>
            )}

            {props.vendor.stats.properties_count_for_sale > 0 && (
                <Text as="p" variant="info_txt_1" css={[textAlign("center"), pb(2)]}>
                    {numberFormat(props.vendor.stats.properties_count_for_sale)} {propertyPluralize(props.vendor.stats.properties_count_for_sale)} w sprzedaży
                </Text>
            )}
        </div>
    );
};

const vendorBoxBase = css`
    ${borderRadius(2)};
    ${elevation(3)};
    ${mv(0)};
    ${mh("auto")};
    min-width: 288px;
    max-width: 375px;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    height: 100%;
    transition: box-shadow 0.2s ease-in-out;
    ${p(2)};

    &:hover {
        ${elevation(2)};
        cursor: pointer;
    }
`;

const vendorLogoStyle = css`
    ${mh("auto")};
    ${pb(2)};
`;

const vendorBoxLink = css`
    display: flex;
    flex-direction: column;
    height: 100%;

    &:hover,
    &:focus {
        color: inherit;
        text-decoration: none;
    }
`;

const vendorMapHolder = css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-grow: 1;
    align-items: center;
    width: 160px;
    height: 160px;
    ${mh("auto")};
    ${mt(0)};
    ${mb(3)};
`;
import * as React from "react";
import {css, useTheme} from "@emotion/react";

import {borderRadius, color, elevation, mb, mh, mt, mv, p, pb, textAlign} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {numberFormat, pluralize} from "@pg-mono/string-utils";
import {LISTING_VENDOR_TEST_IDS} from "@pg-mono/test-ids";

import {MapOfPoland} from "../../atoms/map/MapOfPoland";
import {useBoxHandlerWithAnchor} from "../../hooks/use_box_handler_with_anchor";
import {useResponsiveLinkTarget} from "../../hooks/useResponsiveLinkTarget";

export interface IVendorBox {
    vendor: IVendorBoxVendor;
}

export interface IVendorBoxVendor {
    id: number;
    logo: {
        v_log_120x90: string;
    };
    name: string;
    headquarters: {
        type: 1 | 2;
        address: string;
        region: {
            id: number;
            full_name: string;
        };
    };
    regions: string[] | null;
    slug: string;
    stats: {
        offers_count_for_sale: number;
        properties_count_for_sale: number;
    };
}

export const VendorBox = (props: IVendorBox) => {
    const theme = useTheme();
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const vendorLink = rpAppLink.vendor.detail.base({vendorSlug: props.vendor.slug, vendorId: props.vendor.id});
    const offerPluralize = pluralize(["inwestycja", "inwestycje", "inwestycji"]);
    const propertyPluralize = pluralize(["nieruchomość", "nieruchomości", "nieruchomości"]);
    const vendorBoxHandler = useBoxHandlerWithAnchor(vendorLink);

    return (
        <div css={vendorBoxBase} onClick={vendorBoxHandler} data-testid={LISTING_VENDOR_TEST_IDS.CARD}>
            <Image alt={`${props.vendor.name} logo`} src={props.vendor.logo.v_log_120x90} css={vendorLogoStyle} height="90" width="auto" />
            <Text as="h2" variant="headline_4" css={[mt(0), mb(0.5), p(0), textAlign("center")]} className="bt">
                <a href={vendorLink} css={vendorBoxLink} title={props.vendor.name} target={responsiveLinkTarget}>
                    {props.vendor.name}
                </a>
            </Text>

            {props.vendor.headquarters && (
                <Text as="address" variant="info_txt_3" css={[mb(4), textAlign("center"), color(theme.colors.gray["600"])]}>
                    {props.vendor.headquarters.region.full_name}, {props.vendor.headquarters.address}
                </Text>
            )}

            <div css={[vendorMapHolder]} data-testid={LISTING_VENDOR_TEST_IDS.MAP_CONTAINER}>
                <MapOfPoland regions={props.vendor.regions} />
            </div>

            {props.vendor.stats.offers_count_for_sale > 0 && (
                <Text as="p" variant="info_txt_1" css={[textAlign("center"), pb(1)]}>
                    {numberFormat(props.vendor.stats.offers_count_for_sale)} {offerPluralize(props.vendor.stats.offers_count_for_sale)} w sprzedaży
                </Text>
            )}

            {props.vendor.stats.properties_count_for_sale > 0 && (
                <Text as="p" variant="info_txt_1" css={[textAlign("center"), pb(2)]}>
                    {numberFormat(props.vendor.stats.properties_count_for_sale)} {propertyPluralize(props.vendor.stats.properties_count_for_sale)} w sprzedaży
                </Text>
            )}
        </div>
    );
};

const vendorBoxBase = css`
    ${borderRadius(2)};
    ${elevation(3)};
    ${mv(0)};
    ${mh("auto")};
    min-width: 288px;
    max-width: 375px;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    height: 100%;
    transition: box-shadow 0.2s ease-in-out;
    ${p(2)};

    &:hover {
        ${elevation(2)};
        cursor: pointer;
    }
`;

const vendorLogoStyle = css`
    ${mh("auto")};
    ${pb(2)};
`;

const vendorBoxLink = css`
    display: flex;
    flex-direction: column;
    height: 100%;

    &:hover,
    &:focus {
        color: inherit;
        text-decoration: none;
    }
`;

const vendorMapHolder = css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-grow: 1;
    align-items: center;
    width: 160px;
    height: 160px;
    ${mh("auto")};
    ${mt(0)};
    ${mb(3)};
`;
